import type { GridColDef } from '@mui/x-data-grid';
import type { Customer } from '@vy/types';
import { vyDate, isNullOrUndefined } from '@vy/utils';
import { Link } from 'react-router-dom';
import { formatDate } from '../../../../../../../utils/date';

export type MatchedCustomerSample = {
  alias: string;
  name: string | undefined;
  matchedAt: Date | undefined;
};

export function buildMatchedCustomersTableColumns(
  customers: Customer[],
): GridColDef<MatchedCustomerSample>[] {
  const findCustomerId = (alias?: string) => {
    if (isNullOrUndefined(alias)) {
      return undefined;
    }

    const foundCustomer = customers.find((customer) => {
      return customer.externalId === alias || customer.aliases?.includes(alias);
    });

    return foundCustomer?.id;
  };

  return [
    {
      field: 'name',
      valueGetter: (_value, row) => row,
      headerName: 'Name',
      flex: 1,
      renderCell: ({ value }) => (
        <Link
          to={`/customers/${findCustomerId(value.alias)}`}
          state={{ name: value }}
          onMouseEnter={(event) => (event.currentTarget.style.textDecoration = 'underline')}
          onMouseLeave={(event) => (event.currentTarget.style.textDecoration = 'none')}
        >
          {value.name}
        </Link>
      ),
    },
    {
      field: 'alias',
      valueGetter: (_value, row) => row.alias,
      headerName: 'Alias',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
    },
    {
      field: 'matchedAt',
      valueGetter: (_value, row) => row.matchedAt,
      headerName: 'Matched At',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      renderCell: ({ value }) => <span className="font-sans text-black">{formatDate(vyDate(value))}</span>,
    },
  ];
}
